/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

/**
 * GetDesktopConnectionRedirectHandler.js--
 *
 *      inherited Class to handle <get-desktop-connection-redirect>
 */

import RedirectHandler from "./redirectHandler";
export default function GetDesktopConnectionRedirectHandler() {
   this.requestTag = "get-desktop-connection-redirect"; // the XML request tag name
   this.responseTag = "desktop-connection-redirect"; // the XML response tag name
}

// inherits RedirectHandler prototype
GetDesktopConnectionRedirectHandler.prototype = new RedirectHandler();

// constructor
GetDesktopConnectionRedirectHandler.constructor = GetDesktopConnectionRedirectHandler;
